"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TheaterInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _TheaterInfo = require("./TheaterInfo.styled");
var _constants = require("../../../constants");
var _utils = require("../../../utils");
var ValuePair = function ValuePair(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    _ref$sourceType = _ref.sourceType,
    sourceType = _ref$sourceType === void 0 ? '' : _ref$sourceType;
  var source = '';
  if (sourceType === _constants.EMBED_SOURCE_TYPE) {
    source = '3rd party player';
  }
  if (sourceType === _constants.BROADCAST_SOURCE_TYPE) {
    source = 'Studio';
  }
  return /*#__PURE__*/_react["default"].createElement(_TheaterInfo.LabelContainer, null, /*#__PURE__*/_react["default"].createElement(_TheaterInfo.StyledIcon, {
    icon: icon
  }), /*#__PURE__*/_react["default"].createElement(_TheaterInfo.StyledLabel, null, label, source ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\xA0- ", /*#__PURE__*/_react["default"].createElement("strong", null, source)) : null));
};
var TheaterInfo = exports.TheaterInfo = function TheaterInfo(_ref2) {
  var startOn = _ref2.startOn,
    endOn = _ref2.endOn,
    sourceType = _ref2.sourceType,
    description = _ref2.description,
    authentication = _ref2.authentication,
    featuredImage = _ref2.featuredImage,
    onTheaterInfoEdit = _ref2.onTheaterInfoEdit;
  var passwordText = 'Password disabled';
  if (authentication && authentication.type !== 'none' && authentication.password) {
    passwordText = 'Password enabled';
  }
  return /*#__PURE__*/_react["default"].createElement(_TheaterInfo.StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(_TheaterInfo.StyledHeader, null, /*#__PURE__*/_react["default"].createElement(_TheaterInfo.StyledTitle, null, "Theater Info"), /*#__PURE__*/_react["default"].createElement(_TheaterInfo.StyledEditButton, {
    onClick: onTheaterInfoEdit
  }, "Edit")), /*#__PURE__*/_react["default"].createElement(_TheaterInfo.Content, null, featuredImage ? /*#__PURE__*/_react["default"].createElement(_TheaterInfo.StyledImage, {
    src: featuredImage
  }) : /*#__PURE__*/_react["default"].createElement(_TheaterInfo.DefaultImage, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faImage
  })), /*#__PURE__*/_react["default"].createElement(_TheaterInfo.InfoContainer, null, /*#__PURE__*/_react["default"].createElement(ValuePair, {
    icon: _freeSolidSvgIcons.faCalendar,
    label: (0, _utils.getEventStartDate)(startOn)
  }), /*#__PURE__*/_react["default"].createElement(ValuePair, {
    icon: _freeSolidSvgIcons.faClock,
    label: (0, _utils.getEventStartTime)(startOn, endOn)
  }), /*#__PURE__*/_react["default"].createElement(ValuePair, {
    icon: _freeSolidSvgIcons.faLock,
    label: passwordText
  }), /*#__PURE__*/_react["default"].createElement(ValuePair, {
    icon: _freeSolidSvgIcons.faPlay,
    label: "Player source",
    sourceType: sourceType
  }))), description ? /*#__PURE__*/_react["default"].createElement(_TheaterInfo.DescriptionWrapper, null, /*#__PURE__*/_react["default"].createElement(_TheaterInfo.DescriptionTitle, null, "Description"), /*#__PURE__*/_react["default"].createElement(_TheaterInfo.Description, null, description)) : null);
};